module.exports = __webpack_public_path__ + "static/media/eagle.8a93b34d.jpeg";